/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SetSequenceStepActiveMutationRequest,
  SetSequenceStepActiveMutationResponse,
  SetSequenceStepActivePathParams,
  SetSequenceStepActive400,
  SetSequenceStepActive404,
} from '../types/SetSequenceStepActive'

function getSetSequenceStepActiveUrl({
  bison_step_id,
}: {
  bison_step_id: SetSequenceStepActivePathParams['bison_step_id']
}) {
  const res = {
    method: 'PATCH',
    url: `/api/v1/emailbison/sequence-steps/${bison_step_id}/active/` as const,
  }
  return res
}

/**
 * @description Activate or deactivate a single sequence-step variant.
 * Deactivating keeps the variant and its stats; it only stops it receiving
 * split traffic, and is reversible. Only variant steps may be toggled
 * (non-variant originals are rejected with 400).
 * Endpoint:
 * - PATCH /api/emailbison/sequence-steps/<bison_step_id>/active/
 * body: {"active": true|false}
 * @summary Activate or deactivate a sequence-step variant
 * {@link /api/v1/emailbison/sequence-steps/:bison_step_id/active/}
 */
export async function setSequenceStepActive(
  {
    bison_step_id,
  }: { bison_step_id: SetSequenceStepActivePathParams['bison_step_id'] },
  data?: SetSequenceStepActiveMutationRequest,
  config: Partial<RequestConfig<SetSequenceStepActiveMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    SetSequenceStepActiveMutationResponse,
    ResponseErrorConfig<SetSequenceStepActive400 | SetSequenceStepActive404>,
    SetSequenceStepActiveMutationRequest
  >({
    method: 'PATCH',
    url: getSetSequenceStepActiveUrl({ bison_step_id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
